// extracted by mini-css-extract-plugin
export default {"main":"NivelEstudiosSelector_main__Zvc1O"};